//@flow
import configuration from '../config/config'

class FileUtils {
    configuration;
    constructor(configuration: any){
        this.configuration = configuration;
    }
    getAbsoluteUrl = (relativeUrl: string) => {
        return this.configuration.endpointUrl + relativeUrl;
    };
}

let fileUtils = new FileUtils(configuration);

export default  {
    getAbsoluteUrl : (relativeUrl:string): string => {
        return fileUtils.getAbsoluteUrl(relativeUrl);
    },
    getArchivesUrl:  () => fileUtils.getAbsoluteUrl("/tam/search/arkives"),
    getOutlinesUrl:  () =>  fileUtils.getAbsoluteUrl("/tam/search/outlines"),
    getArtistNamesUrl:  () =>  fileUtils.getAbsoluteUrl("/tam/search/artist-names"),
    getSagaSeriesUrl:  () =>  fileUtils.getAbsoluteUrl("/tam/search/saga-series")
}


// WEBPACK FOOTER //
// ./src/utils/FileUtils.js